<div class="container mt-3">
    <div class="row">
        <div class="col">
            <img src="https://upload.wikimedia.org/wikipedia/commons/c/c0/Digital_rain_animation_medium_letters_shine.gif" class="rounded matrix-img" alt="Matrix Code">
        </div>
        <div class="col mt-auto">
           <h6>Fecha de imagen:{{timestamp}}</h6>
        </div>
        <div class="col">
            <img src="assets/images/besu.png" class="rounded" alt="Redsys">
        </div>
    </div>
    
</div>
